const SocialLinks =()=>{
    return(
        <p className="footer-text mt-3">
            <button className="custom-link" onClick={() => window.open('https://web.facebook.com/norrenberger?_rdc=1&_rdr')}><i className="bi-facebook"></i></button>
            <button className="custom-link" onClick={() => window.open('https://www.instagram.com/norrenberger/')}><i className="bi-instagram"></i></button>
            <button className="custom-link" onClick={() => window.open('https://www.linkedin.com/company/norrenberger/')}><i className="bi-linkedin"></i></button>
            <button className="custom-link" onClick={() => window.open('https://twitter.com/norrenberger')}><i className="bi-twitter"></i></button>
            <button className="custom-link" onClick={() => window.open('https://wa.me/2349085289934')}><i className="bi-instagram"></i></button>
        </p>
    )
}
 
export default SocialLinks;

